import snakecaseKeys from 'snakecase-keys'
import axiosIns from '@/plugins/axios'

export default {
  getSummary(date) {
    return axiosIns.get('/v2/eod_report/daily_report_summary', {
      params: snakecaseKeys({ date }),
    })
  },
}
